import Register from "../Allcomponent/register"
function Registerr(){
    return(
        <>
        <Register/>
        </>
    )
}
export default Registerr